<template>
  <div class="patientWrapper">
    <!-- 头像 -->
    <div class="header">
      <div v-if="patient.patientHeadUrl" class="avatar">
        <img :src="patient.patientHeadUrl" alt="" />
      </div>
      <div class="basicInfo">
        <div v-if="patient.patientName" class="name">{{ patient.patientName }}</div>
        <div v-if="patient.patientGender" class="sex">{{ patient.patientGender }}</div>
        <div v-if="patient.patientAge" class="age">{{ patient.patientAge }}岁</div>
      </div>
    </div>

    <!-- 诊断信息 -->
    <div class="diagnosisInfo">
      <div v-for="(p, index) in patientDiagnosisList" :key="index" class="diagnosisItem">
        <div class="label">{{ p.label }}</div>
        <div class="dot">：</div>
        <div class="value">{{ patient[p.key] || '无' }}</div>
      </div>
    </div>

    <!-- 服务信息 -->
    <div class="serviceInfo">
      <div class="lastService">
        <template v-if="activeTab !== 1">
          <div>最近一次服务</div>
          <div class="date">
            {{ formatDate(patient.lastServiceTime) }}
          </div>
        </template>
      </div>
      <RightOutlined class="right-icon" />
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { RightOutlined } from '@ant-design/icons-vue'
import moment from 'moment'
const props = defineProps({
  // 患者信息
  patient: {
    type: Object,
    default: () => ({})
  },
  // 诊断列表
  patientDiagnosisList: {
    type: Array,
    default: () => []
  },
  activeTab: {
    type: Number,
    default: 0
  }
})
// 格式化时间
const formatDate = time => {
  if (!time) return ''
  const m = moment(time)
  return m.isValid() ? m.format('YYYY-MM-DD HH:mm') : ''
}
</script>

<style scoped lang="scss">
.patientWrapper {
  padding: 12px 16px;
  border-radius: 4px;
  background: #fafafa;
  margin: 0 16px 12px 0;
  border: 1px solid transparent;

  &:hover {
    background: #1890ff0a;
    cursor: pointer;
  }

  &:active {
    border: 1px solid #1890ff66;
    background: #1890ff0a;
  }

  .header {
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .avatar {
      border-radius: 8px;
      margin-right: 20px;

      img {
        width: 36px;
        height: 36px;
      }
    }

    .basicInfo {
      display: flex;
      align-items: flex-end;
      color: #333;
      font-weight: 600;

      .name {
        margin-right: 20px;
        font-size: 17px;
      }

      .sex,
      .age {
        font-size: 14px;
      }

      .sex {
        margin-right: 12px;
      }
    }
  }

  .diagnosisInfo {
    padding-bottom: 8px;
    border-bottom: 1px solid #edf0f5;

    .diagnosisItem {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      font-size: 16px;
      line-height: 22px;

      .label {
        width: 65px;
        color: #999;
        text-align: justify;
        text-align-last: justify;
      }

      .dot {
        color: #999;
      }

      .value {
        overflow: hidden;
        flex: 1;
        color: #333;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .serviceInfo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 11px;
    font-size: 14px;

    .lastService {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: space-between;
      color: #333;
      height: 22px;

      .date {
        display: flex;
        align-items: center;
        color: #999;
      }
    }
    .right-icon {
      font-size: 14px;
      color: #999;
      margin-left: 16px;
    }
  }
}
</style>
